import { render, staticRenderFns } from "./NoSanctionsCheck.vue?vue&type=template&id=284241b2&"
import script from "./NoSanctionsCheck.vue?vue&type=script&lang=js&"
export * from "./NoSanctionsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports